import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import './style.css';
import VisionText from '../../assets/VisionText.svg';
import { useNavigate } from 'react-router-dom';


const NavAppTitle: React.FC = () => {
    const navigate = useNavigate()
    return (
        <Box className="nav-app-title-container" onClick={() => navigate('/')} >
            <img data-testid='header-image' src={VisionText} alt={'vision_icon'} className='project_icon_img' />
            <Box className="nav-app-text-block">
                <div className="nav-app-title">
                    Vision
                </div>
                <div className="nav-app-desc">
                    Omni supply chain visibility
                </div>
            </Box>
        </Box>
    );
};

export default NavAppTitle;